export default __webpack_public_path__ + "static/media/teng-hsiung.d5b27b0a.png";